import {
	BY_POPULARITY,
	BY_PRICE_AND_POPULARITY,
	compose,
	createBooleanSorter,
	createSorter,
	getSortingFunction,
	hasPrice,
	isValidSorting,
} from "@escapio/portal/components/hotel-list/sorting/Sorters";
import { contains as favoritesContain } from "@escapio/portal/state/FavoriteHotels";
import { inTheNear } from "@escapio/portal/components/hotel-list/hotel-is-in-the-near";
import { travelData } from "@escapio/portal/state/travelData.js";
import { hasEscapioRate } from "@escapio/portal/state/escapio-deals-helpers";

export const getTopEscapioDealHotelId = (hotels, prices) => {
	return hotels?.filter(hasEscapioRate).sort(
		compose(
			byNotInTheNear,
			createBooleanSorter(hotel => !prices[hotel.id]?.isMinPrice),
			createSorter(hotel => hotel.escapio_deal.position, false),
		)(prices, travelData.hasDates),
	)[0]?.id;
};

const byNotInTheNear = createBooleanSorter(hotel => !inTheNear(hotel));
const byTopHotel = topHotelId =>
	createBooleanSorter(hotel => hotel.id === topHotelId);
const byTopEscapioDealHotel = (currentSorting, topEscapioDealHotelId) =>
	createBooleanSorter(
		hotel =>
			currentSorting === BY_POPULARITY && hotel.id === topEscapioDealHotelId,
	);

export const belongsEDLOnlyGroup =
	(currentSorting, topHotelId) => (hotel, prices, hasDates) =>
		hasDates &&
		hotel.id !== topHotelId &&
		!prices[hotel.id].isLoading &&
		!hasPrice(hotel, prices) &&
		(currentSorting === BY_PRICE_AND_POPULARITY || !hotel.disabled_prices);

const belongsAvailableGroup =
	(currentSorting, topHotelId) => (hotel, prices, hasDates) =>
		!belongsEDLOnlyGroup(currentSorting, topHotelId)(hotel, prices, hasDates);

const byAvailableGroup = (currentSorting, topHotelId) =>
	createBooleanSorter(belongsAvailableGroup(currentSorting, topHotelId));

const byFavorites = currentSorting =>
	createBooleanSorter(
		hotel => currentSorting === BY_POPULARITY && favoritesContain(hotel.id),
	);

const hotelListSorter = (currentSorting, topHotelId, topEscapioDealHotelId) =>
	compose(
		byNotInTheNear,
		byTopHotel(topHotelId),
		byTopEscapioDealHotel(currentSorting, topEscapioDealHotelId),
		byAvailableGroup(currentSorting, topHotelId),
		byFavorites(currentSorting),
		getSortingFunction(currentSorting),
	);

export const sortForHotelList = (
	prices,
	currentSorting,
	topHotelId,
	topEscapioDealHotelId,
) => {
	if (!isValidSorting(currentSorting)) {
		throw new Error(`Invalid sorting value: ${currentSorting}`);
	}

	return hotelListSorter(
		currentSorting,
		topHotelId,
		topEscapioDealHotelId,
	)(prices, travelData.hasDates);
};
